import { useTranslation } from 'react-i18next';

import { Layout } from '../../../../../components/auth';
import { Button } from '../../../../../components/common';
import { IForgotPasswordDoneProps } from './types';

export const ForgotPasswordDone = ({ onComplete }: IForgotPasswordDoneProps) => {
  const { t } = useTranslation();

  return (
    <Layout title={t('forgotPassword.title.success')}>
      <p className="typography-paragraph-3 text-text-secondary mt-2 mb-6">{t('forgotPassword.subtitle.success')}</p>

      <div className="flex">
        <Button text={t('forgotPassword.button.back')} type="tertiary" onClick={onComplete} />
      </div>
    </Layout>
  );
};
